var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaravan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97 90v-6c2.757 0 5-2.243 5-5V57c0-11.58-9.42-21-21-21H27c-4.962 0-9 4.038-9 9v36c0 1.655 1.345 3 3 3h36v6H21c-4.962 0-9-4.037-9-9V45c0-8.27 6.73-15 15-15h54c14.888 0 27 12.112 27 27v22c0 6.065-4.935 11-11 11Z",
    fill: "#222",
    className: "fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114 84H81v6h33v-6ZM32.752 87h-6V52c0-3.86 3.14-7 7-7h10c3.86 0 7 3.14 7 7v11h-6V52a1 1 0 0 0-1-1h-10a1 1 0 0 0-1 1v35Z",
    fill: "#222",
    className: "fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.752 87h-6V72h-3v-6h6l3 3v18ZM86 66h-7c-3.86 0-7-3.14-7-7v-7c0-3.86 3.14-7 7-7h7c3.86 0 7 3.14 7 7v7c0 3.86-3.14 7-7 7Zm-7-15a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1h-7ZM66 97.5c-5.79 0-10.5-4.71-10.5-10.5S60.21 76.5 66 76.5c2.805 0 5.442 1.093 7.425 3.075A10.433 10.433 0 0 1 76.5 87c0 5.79-4.71 10.5-10.5 10.5Zm0-15c-2.48 0-4.5 2.017-4.5 4.5s2.017 4.5 4.5 4.5 4.5-2.017 4.5-4.5a4.47 4.47 0 0 0-1.317-3.183A4.47 4.47 0 0 0 66 82.5Z",
    fill: "#222",
    className: "fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87 87h-6c0-8.27-6.73-15-15-15h-9v-6h9c11.58 0 21 9.42 21 21Z",
    fill: "#222",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaravan);
export default __webpack_public_path__ + "static/media/caravan.ebe2d87e.svg";
export { ForwardRef as ReactComponent };